import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ArtaForWho() {
  const forWho = ['Persoane care se simt constant stresate sau copleșite. Ești mereu pe fugă, mereu cu ceva de făcut, mereu cu un gând în plus. Și simți că nu mai poți continua așa.', 'Oameni ocupați care nu reușesc să se relaxeze cu adevărat. Vine weekendul, vine concediul, dar mintea tot nu se oprește. Vrei să înveți cum să te deconectezi real.', 'Persoane care se pun mereu pe ultimul loc. Te ocupi de toată lumea, dar uiți de tine. Și ajungi epuizat/ă, fără energie și fără bucurie.', 'Oameni care vor mai multă pace, claritate și echilibru. Simți că viața poate fi trăită altfel. Nu doar supraviețuită. Și vrei să înveți cum.'];
  const notForWho = ['Persoane care caută soluții rapide fără aplicare. Tehnicile din curs funcționează, dar doar dacă le practici. Dacă vrei rezultate fără efort, nu e cursul potrivit.', 'Cei care nu cred că stresul poate fi gestionat prin practică. Dacă crezi că "așa e viața" și că nu ai ce face, acest curs nu te va ajuta.', 'Oameni care nu sunt dispuși să schimbe obiceiurile. Echilibrul nu vine din a face același lucru și a spera la alt rezultat. Vine din a schimba câte un obicei mic, în fiecare zi.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-139">
      <div className="max-w-6xl mx-auto px-6" data-id="element-140">
        <SectionHeading title="Pentru cine este acest curs" data-id="element-141" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-143">
            <div className="flex items-center gap-4 mb-8" data-id="element-144">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-145">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-146" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-147">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-148">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-149">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-150" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-151">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-152">
            <div className="flex items-center gap-4 mb-8" data-id="element-153">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-154">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-155" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-156">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-157">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-158">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-159" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-160">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-161">
          <CTAButton data-id="element-162" />
        </motion.div>
      </div>
    </section>;
}